export const defaultAddressRadiusInMeter = 350;
